import React from 'react';
import OverlineSmall from 'components/Typography/OverlineSmall';
import Checkbox from 'components/DesignSystem/Checkbox';

interface CheckboxSelectorItem {
  value: string;
  label: string;
}

export default function CheckboxSelector({
  itemCount,
  filteredItems,
  selectedItems,
  setValue,
  searchTerm,
  selectAllLabel,
  selectedLabel,
  unselectedLabel,
}: {
  itemCount: number;
  filteredItems: CheckboxSelectorItem[],
  selectedItems: string[];
  setValue: React.Dispatch<React.SetStateAction<readonly string[]>>;
  searchTerm: string;
  selectAllLabel: string;
  selectedLabel: string;
  unselectedLabel: string;
}) {
  const filteredSelectedOptions = filteredItems.filter((i) => selectedItems.includes(i.value));
  const filteredUnselectedOptions = filteredItems.filter((i) => !selectedItems.includes(i.value));
  const allValues = [...filteredSelectedOptions, ...filteredUnselectedOptions].map((o) => o.value);

  return (
    <>
      {searchTerm === '' && (
        <Checkbox
          label={selectAllLabel}
          onChange={() => setValue(allValues)}
          checked={selectedItems.length === itemCount}
        />
      )}
      {filteredSelectedOptions.length !== 0 && (
        <div className="mt-2">
          <OverlineSmall>{selectedLabel}</OverlineSmall>
          {filteredSelectedOptions.map((item) => (
            <Checkbox
              key={item.value}
              label={item.label}
              value={item.value}
              onChange={() => setValue((oldValue) => oldValue.filter((v) => v !== item.value))}
              checked
            />
          ))}
        </div>
      )}
      {filteredUnselectedOptions.length > 0 && (
        <div className="mt-2">
          <OverlineSmall>{unselectedLabel}</OverlineSmall>
          {filteredUnselectedOptions.map((item) => (
            <Checkbox
              key={item.value}
              label={item.label}
              value={item.value}
              onChange={() => setValue((oldValue) => [...oldValue, item.value])}
              checked={false}
            />
          ))}
        </div>
      )}
    </>
  );
}
